"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var Columns_1 = require("./Columns");
// Styled version of Menu statics
var MenuSubMenu = styled_components_1.default(antd_1.Menu.SubMenu)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var MenuItem = styled_components_1.default(antd_1.Menu.Item)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var MenuDivider = styled_components_1.default(antd_1.Menu.Divider)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var MenuItemGroup = styled_components_1.default(antd_1.Menu.ItemGroup)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
// Menu Item styled for top menu
exports.TopMenuItem = styled_components_1.default(MenuItem)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    a:hover {\n        text-decoration: none;\n    }\n"], ["\n    a:hover {\n        text-decoration: none;\n    }\n"])));
// Menu Item styled for left menu
exports.LeftMenuItem = styled_components_1.default(MenuItem)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    &&& {\n        height: auto;\n        line-height: ", ";\n        padding-top: ", ";\n        padding-bottom: ", ";\n        margin: 0;\n        transition: none;\n\n        a:hover {\n            text-decoration: none;\n        }\n    }\n"], ["\n    &&& {\n        height: auto;\n        line-height: ", ";\n        padding-top: ", ";\n        padding-bottom: ", ";\n        margin: 0;\n        transition: none;\n\n        a:hover {\n            text-decoration: none;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.body.lineHeight;
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return theme.spacing[spacing || 'sm'];
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return theme.spacing[spacing || 'sm'];
});
// Menu Item columns for text with an icon
exports.IconMenuItemColumns = styled_components_1.default(Columns_1.Columns).attrs({
    count: 2
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    grid-template-columns: min-content 1fr;\n    justify-items: start;\n    align-items: baseline;\n    grid-gap: 0;\n"], ["\n    grid-template-columns: min-content 1fr;\n    justify-items: start;\n    align-items: baseline;\n    grid-gap: 0;\n"])));
// Our exported styled component version of AntTabs will need to have a reference to the styled
// component version of Menu.
// There is a type swap here, this makes typescript happy (Antd.Menu.SubMenu => MenuSubMenu).
// This is fine, since consumers will use the styled version and 'ref' grabs the inner component.
var VarnishMenu = /** @class */ (function (_super) {
    __extends(VarnishMenu, _super);
    function VarnishMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VarnishMenu.SubMenu = MenuSubMenu;
    VarnishMenu.Item = MenuItem;
    VarnishMenu.Divider = MenuDivider;
    VarnishMenu.ItemGroup = MenuItemGroup;
    return VarnishMenu;
}(antd_1.Menu));
// Styled left version of Menu.
var StyledLeftMenu = styled_components_1.default(VarnishMenu).attrs(function () { return ({
    mode: 'inline'
}); })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    border-right-color: transparent;\n    transition: none;\n"], ["\n    border-right-color: transparent;\n    transition: none;\n"])));
// Styled top version of Menu.
var StyledTopMenu = styled_components_1.default(VarnishMenu).attrs({
    mode: 'horizontal'
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    && {\n        display: flex;\n        line-height: 77px; /* TODO: get rid of the line-height based approach, ideally we'd use padding instead, so the text could wrap cleanly */\n        border-bottom: 0;\n    }\n"], ["\n    && {\n        display: flex;\n        line-height: 77px; /* TODO: get rid of the line-height based approach, ideally we'd use padding instead, so the text could wrap cleanly */\n        border-bottom: 0;\n    }\n"])));
// We trick Typescript here by first casting to unknown and then casting to the type we'd like to export.
// We do this so that the exported type includes the static properties, which we lose otherwise.
exports.LeftMenu = StyledLeftMenu;
exports.TopMenu = StyledTopMenu;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=Menu.js.map